import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { urlSnapshotToRedirectPath } from '@core/utils/url-snapshot-to-redirect-path';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated) {
    router.navigate(['/entrar'], {
      queryParams: urlSnapshotToRedirectPath(),
    });
    return false;
  }

  return true;
};
